import colors from '../colors';

export default {
  baseStyle: {
    fontSize: 14,
    marginTop: 4,
    marginBottom: 1,
    fontWeight: 'semibold',
    color: colors.blueGrey[1000],
  },
};
